import type { PoisStoreContent, StaticMapStoreContent } from '../../../types';
import type { PageLoadEvent } from './$types';
import { GetStaticMapStore } from '$houdini';
import { AddressEntitiesByAddressLength } from '$lib/seo/address';
import { derived, get, type Readable } from 'svelte/store';

const STATIC_MAP_HEIGHT = 382;
const STATIC_MAP_WIDTH = 500;
const STATIC_MAP_STYLE = 'template-vector-michelin-v11';

export async function getStaticMap(
	event: PageLoadEvent,
	poisStoreContent: PoisStoreContent,
	urlAddress?: string,
): Promise<Readable<StaticMapStoreContent | undefined>> {
	const selectedAddressCenter = poisStoreContent.selectedAddressCenter;
	const getStaticMapStore = new GetStaticMapStore();

	if (selectedAddressCenter && urlAddress) {
		const addressEntities = urlAddress.split('/');
		await getStaticMapStore
			.fetch({
				event,
				blocking: true,
				variables: {
					input: {
						center: selectedAddressCenter,
						entityType: AddressEntitiesByAddressLength[addressEntities.length - 1],
						height: STATIC_MAP_HEIGHT,
						width: STATIC_MAP_WIDTH,
						style: STATIC_MAP_STYLE,
					},
				},
			})
			.catch((error) => {
				// Workaround to make sure we subscribe and unsubscribe after an error is thrown
				// This avoids a memory leak coming from the houdini store
				//
				// See https://github.com/HoudiniGraphql/houdini/issues/1294
				get(getStaticMapStore);

				throw error;
			});

		return derived(getStaticMapStore, ($store) => {
			if (!$store.data) {
				// should never happen because blocking set to true
				throw new Error('getStaticMapStore data is undefined');
			}

			const staticMapStore = get(getStaticMapStore);

			if (staticMapStore.data?.getStaticMap.__typename === 'GetStaticMapSuccessResult') {
				return {
					url: staticMapStore.data.getStaticMap.url,
					height: staticMapStore.data.getStaticMap.height.toString(),
					width: staticMapStore.data.getStaticMap.width.toString(),
				};
			}
		});
	}

	return derived(getStaticMapStore, (_) => {});
}
